export default {"src":"/_next/static/media/WBD.f1ba4bb9.svg","height":18,"width":18};